<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Voeging met bestaande dochtermaatschappijen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Er is sprake van een voeging van een dochtermaatschappij als:</p>
                <ul>
                    <li>een nieuwe fiscale eenheid is ontstaan.</li>
                    <li>een bestaande fiscale eenheid is uitgebreid.</li>
                </ul>
                <p>Voor het aangaan van een fiscale eenheid moet je een schriftelijk verzoek indienen bij het
                    belastingkantoor waar de moedermaatschappij onder valt. De Belastingdienst beslist met een
                    beschikking over dit verzoek. De fiscale eenheid kan op elk moment ingaan, maar niet eerder dan 3
                    maanden vóór de datum van het schriftelijk verzoek.</p>
                <p>
                    Vul bij een 'Ja' de specificatie 'Fiscale eenheid - Specificatie voeging' in.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Ontvoeging van dochtermaatschappijen
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Van ontvoeging is bijvoorbeeld sprake als de vennootschap niet meer in het bezit was van ten minste
                    95% van de aandelen in de dochtermaatschappij. Onder ontvoegingen vallen niet de geliquideerde
                    dochtermaatschappijen. De dochtermaatschappij is weer zelfstandig belastingplichtig vanaf het moment
                    dat ze geen deel meer uitmaakt van de fiscale eenheid.</p>
                <p>Kies dus 'Ja' als er in dit boekjaar dochtermaatschappijen zijn ontvoegd, bijvoorbeeld omdat de
                    vennootschap niet meer in het bezit was van ten minste 95% van de aandelen in de
                    dochtermaatschappij. Kies ook 'Ja' als de fiscale eenheid door de ontvoeging is beëindigd. Onder
                    ontvoegingen vallen niet de geliquideerde of failliete dochtermaatschappijen.</p>
                <p>
                    Vul bij een 'Ja' de specificatie 'Fiscale eenheid - Specificatie ontvoeging' in.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Beëindiging van de fiscale eenheid door liquidatie
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Bij faillissement van een maatschappij eindigt de fiscale eenheid voor die maatschappij bij
                    opheffing/beëindiging van het faillissement.</p>
                <p>
                    Vul bij een 'Ja' de specificatie 'Fiscale eenheid - Specificatie ontbinding' in.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Meegeven verliezen ontvoegde dochter
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>
                    Dit betreft een verzoekt om verliezen uit de fiscale eenheid die aan dochtermaatschappijen zijn toe
                    te rekenen, na ontvoeging te mogen meegeven aan die dochtermaatschappij. Een en ander in de zin van
                    art. 15af, lid 3 Vpb. Je kunt dit verzoek doen in de aangifte over het laatste boekjaar dat de
                    dochtermaatschappij deel uitmaakt van de fiscale eenheid.
                </p>
                <p>
                    Bij een 'Ja' vul je hier de specificatie 'Fiscale eenheid - Specificatie verliezen' in met de naam en het fiscale
                    nummer van de betreffende dochter.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Geen verbreking vanwege juridische fusie
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Dit betreft een verzoek om verliezen uit de fiscale eenheid die aan een juridisch gefuseerde
                    dochtermaatschappij zijn toe te rekenen, na ontvoeging te mogen meegeven aan de dochtermaatschappij
                    die als verkrijgende rechtspersoon bij deze fusie was betrokken. Een en ander in de zin van artikel
                    18, 4 Besluit fiscale eenheid 2003. <br/>
                    Bij een 'Ja' vul je de specificatie 'Fiscale eenheid - Specificatie verliezen' in met de naam en het fiscale nummer van de
                    betreffende dochtermaatschappij.
                </p>
                <p>Als de dochtermaatschappij die behoort tot een fiscale eenheid bij een juridische splitsing ophoudt
                    te bestaan, eindigt voor die maatschappij de fiscale eenheid. Als de verkrijgende rechtspersoon in
                    de fiscale eenheid wordt opgenomen, wordt op verzoek de fiscale eenheid met de verdwijnende
                    rechtspersoon geacht niet te zijn verbroken</p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Meegeven verliezen aan verkrijgende vennootschap bij fusie
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>
                    Dit betreft een verzoekt om verliezen uit de fiscale eenheid die aan een juridisch gesplitste
                    dochtermaatschappij zijn toe te rekenen, na ontvoeging te mogen meegeven aan de dochtermaatschappij
                    die als verkrijgende rechtspersoon bij deze splitsing was betrokken. Een en ander in de zin van
                    artikel 17, 4 Besluit fiscale eenheid 2003. Je kunt dit verzoek doen in de aangifte over het laatste
                    boekjaar dat de dochtermaatschappij deel uitmaakt van de fiscale eenheid.
                </p>
                <p>
                    Bij een 'Ja' vul je de specificatie 'Fiscale eenheid - Specificatie verliezen' in met de naam en het fiscale nummer van de
                    betreffende dochtermaatschappij.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Geen verbreking bij verdwijnen dochtermaatschappij
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>
                    Dit betreft een verzoek om de fiscale eenheid in stand te mogen laten in de zin van artikel 18
                    Besluit fiscale eenheid voor een in dit boekjaar juridisch gefuseerde dochtermaatschappij.
                </p>
                <p>
                    Vul bij een 'Ja' de specificatie 'Fiscale eenheid - specificatie' in met de naam en het fiscale nummer van de betreffende
                    dochtermaatschappij.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading8">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                Meegeven verliezen aan verdwijnende dochter
            </button>
        </h2>
        <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading8"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Het betreft een verzoek om verliezen uit de fiscale eenheid die aan een juridisch gefuseerde
                    dochtermaatschappij
                    zijn toe te rekenen, na ontvoeging te mogen meegeven aan de dochtermaatschappij die als verkrijgende
                    rechtspersoon bij deze fusie was betrokken. Een en ander in de zin van artikel 18, 4 Besluit fiscale
                    eenheid 2003. Je kunt dit verzoek doen in de aangifte over het laatste boekjaar dat de
                    dochtermaatschappij deel uitmaakt van de fiscale eenheid.
                </p>
                <p>
                    Vul bij een 'Ja' de specificatie in met de naam en het fiscale nummer van de
                    betreffende dochtermaatschappij.
                </p>

            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading9">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                Meegeven uitdelingstekort aan ontvoegde dochter
            </button>
        </h2>
        <div id="collapse9" class="accordion-collapse collapse" aria-labelledby="heading9"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Dit betreft uitdelingstekorten van de fiscale eenheid die aan de dochtermaatschappij zijn toe te
                    rekenen, welke je na ontvoeging aan die dochtermaatschappij wenst mee te meegeven. Een en ander is
                    bepaald in artikel 26, 2 Besluit fiscale eenheid 2003.</p>

            </div>
        </div>
    </div>
</div>
